import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

import App from './App'
import locale from './locale'

Vue.config.productionTip = false

Vue.use(VueClipboard)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  i18n: locale
})



// WEBPACK FOOTER //
// ./src/main.js